var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Diamond"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.609 19.1494L22.8508 3.38955C22.359 2.90064 21.6937 2.62622 21.0002 2.62622C20.3067 2.62622 19.6414 2.90064 19.1496 3.38955L3.39956 19.1494C2.91065 19.6412 2.63623 20.3065 2.63623 21C2.63623 21.6935 2.91065 22.3588 3.39956 22.8506L19.1578 38.6105C19.6496 39.0994 20.3149 39.3738 21.0084 39.3738C21.7019 39.3738 22.3672 39.0994 22.859 38.6105L38.6172 22.8506C39.1061 22.3588 39.3805 21.6935 39.3805 21C39.3805 20.3065 39.1061 19.6412 38.6172 19.1494H38.609ZM21.0002 36.75L5.25019 21L21.0002 5.25002L36.7502 21L21.0002 36.75Z",
    fill: "url(#paint0_linear_7265_8887)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7265_8887",
    x1: 21.0084,
    y1: 2.62622,
    x2: 21.0084,
    y2: 49.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0AEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0AEC0",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.140a0df94b9b8617c5ee0d899edf14f3.svg";
export { ForwardRef as ReactComponent };